import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps } from '../Store';
import { Carousel } from 'react-bootstrap';
import ProgressiveJackpot from '../Components/ProgressiveJackpot';
const ImageSlider = ({ banners, actions }) => {
    const [index, setIndex] = useState(0);
    const [progress, setProgress] = useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
        setProgress(0); 
    };

    useEffect(() => {
        if (banners.data.length === 0) {
            actions.bannersActions.getBanners();
        }
    }, []);

    // Simulate progress for the meter
    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prev) => {
                const nextProgress = prev + 2; 
                return nextProgress >= 100 ? 100 : nextProgress;
            });
        }, 100); 

        return () => clearInterval(interval);
    }, [index]);

    return (
        <div className='carousel'>
            <Carousel
                activeIndex={index}
                onSelect={handleSelect}
                className='bg-light p-0'
                fade={true}
                interval={5000}
                variant='dark'
                indicators={false}
                controls={false}
                pause='hover'>
                {banners.data &&
                    banners.data.map(({ background, promo_image, caption, alt, cta, hasJackpot = false }, idx) => (
                        <Carousel.Item key={idx}>
                            <div className='slide' style={{ backgroundImage: `url(${background})` }}>
                                <div className='container-lg promo-slide-content'>
                                    <div className='image-slider'>
                                        {hasJackpot && (
                                            <div className='progressive-jackpot-container'>
                                                <ProgressiveJackpot />
                                            </div>
                                        )}
                                        {promo_image && <img src={promo_image} alt={alt} className='promo-img' />}
                                    </div>

                                    <div className='cta-container'>
                                        {cta?.image && (
                                            <Link to={cta?.action}>
                                                <img src={cta.image} alt={cta?.label} className='callout-img' />
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Carousel.Item>
                    ))}
            </Carousel>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageSlider);
